import React from 'react';
import { Layout } from 'antd';
import ThemeToggle from '../common/ThemeToggle';

const { Content } = Layout;

const AuthLayout = ({ children }) => {
  return (
    <Layout style={{ minHeight: '100vh', background: 'transparent', position: 'relative' }}>
      {/* Theme toggle in top-right corner */}
      <div style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 1000,
      }}>
        <ThemeToggle />
      </div>
      <Content style={{ padding: 0, minHeight: '100vh' }}>
        {children}
      </Content>
    </Layout>
  );
};

export default AuthLayout;
